let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("lyxzP"), load("gcXcg"), load("7dkWW"), load("4gtMV"), load("8wMGm"), load("c6MKV"), load("hVNnP")]).then(() => parcelRequire('5Fm8G'));